export default __webpack_public_path__ + "static/eri_nishihira-8d90b6898ddd46a588745f004e36e0f7.jpg";